export default __webpack_public_path__ + "static/media/joe-teplow.8e902610.jpg";